import {
	IS_FILTERING,
	SET_ACCOUNTS,
	SET_BANNER,
	SET_CURRENT_LIST,
	SET_EXPANDED,
	SET_LISTS,
	SET_TREE,
	TREE_IS_LOADED,
} from '../actions/constants';

/* eslint-disable */
export default function rootReducer(
	state = {},
	action = {}){
	switch (action.type) {
		// callbacks from sagas
		case SET_TREE:
			return {
				...state,
				tree: action.payload,
			}
		case SET_LISTS:
			return {
				...state,
				allLists: [ ...action.payload],
			}
		case TREE_IS_LOADED:
			return {
				...state,
				treeIsLoaded: action.payload,
			}
		case SET_ACCOUNTS:
			return {
				...state,
				accounts: action.payload,
			}

		// hybrid action
		case SET_CURRENT_LIST:
			// sometimes we set the current list syncronously, but when
			// we update it directly from an update call, we want to put that
			// data right in to current list so we don't have to wait for allLists
			// to update (as a result of FETCH_LISTS)
			const match = state.allLists.filter(x => x.id === action.payload.id)[0];
			let { distList = [], name='' } = action.payload; // optional params

			// need to check for a match because there won't be one after a delete call
			if (match && Object.keys(match).length && !distList.length && !name.length) {
				// if the action.payload doesn't have these set, get them from the match
				distList = match.distList;
				name = match.name;
			}

			return {
				...state,
				selectedList: {
					distList,
					id: action.payload.id,
					isFirstLoad: action.payload.isFirstLoad,
					name,
				},
			}

		// normal sync actions
		case SET_EXPANDED:
			return {
				...state,
				expanded: action.payload,
			}
		case IS_FILTERING:
			return {
				...state,
				isFiltering: action.payload,
			}

		// either
		case SET_BANNER:
			return {
				...state,
				banner: {
					message: action.payload.message,
					type: action.payload.type,
					autoDismiss: action.payload.autoDismiss,
				},
			}
		default:
			return state;
	}
}
/* eslint-enable */